import { createRouter, createWebHistory } from 'vue-router'
import appStore from '@/store'
import { getToken } from '@/api/user/user.js'
import { isDesktopDevice } from '../utils/device'

export const initRouter = async () => {
  const dynamicRoutes = isDesktopDevice() ? (await import('./router-desktop')).default : (await import('./router-mobile')).default

  const router = createRouter({
    routes: [...dynamicRoutes],
    history: createWebHistory(),
    scrollBehavior() {
      return { top: 0 }
    }
  })

  router.beforeEach(async (to, from, next) => {
    // pinia 在js文件中使用要写在内容中
    const { changeActiveMenu } = appStore.useMenu
    const { changeUser } = appStore.useUser
    const pto = /^\/document/
    const { fullPath } = to
    if (!pto.test(fullPath)) {
      const res = await getToken()
      if (!res.logined && to.path !== '/index' && to.path !== '/buildwebsite' && to.path !== '/price') {
        if (import.meta.env.APP_FLAG === 'staging') {
          window.open(`https://${isDesktopDevice() ? 'wwww' : 'm'}.sunsky-test.com/user/login.do?toUrl=${encodeURIComponent(window.location.href)}`, '_self')
        } else if (import.meta.env.APP_FLAG === 'dev') {
          window.open(`https://${isDesktopDevice() ? 'wwww' : 'm'}.sunsky-test.com/user/login.do?toUrl=${encodeURIComponent(window.location.href)}`, '_self')
        } else {
          window.open(`https://${isDesktopDevice() ? 'wwww' : 'm'}.sunsky-online.com/user/login.do?toUrl=${encodeURIComponent(window.location.href)}`, '_self')
        }
        next(false)
      } else {
        changeUser(res)
        next()
      }
      changeActiveMenu(to.name)
    } else {
      next()
    }
  })

  return router
}
